module.exports = __webpack_public_path__ + "img/va.4abc7986.svg";